import { styled } from '../../../utils/styled';
import { propStyles } from '../../../utils/propStyles';

const StyledComponent = styled<any, any>('button', 'modalActionClose', 'modal')`
    ${propStyles};
`;

StyledComponent.defaultProps = {
    outline: 'none',
    textAlign: 'center',
    boxShadow: '2px 2px 0 rgb(0 0 0 / 10%)',
    borderStyle: 'solid',
    borderColor: '#0588c5',
    borderRadius: '3px',
    borderWidth: '1px',
    justifyContent: 'center',
    alignItems: 'center',
    background: '#03a9f4',
    minHeight: '24px',
    paddingTop: '4px',
    paddingBottom: '4px',
    paddingLeft: '8px',
    paddingRight: '8px',
    margin: '0 5px 0 0',
    color: '#ffffff',
    cursor: 'pointer',
    hover: {
        borderColor: '#05a2eb',
        backgroundColor: '#00aeff',
    },
};

export default StyledComponent;



// WEBPACK FOOTER //
// ./src/Components/Modal/StyledComponents/ModalActionClose.tsx